export default __webpack_public_path__ + "static/media/photo--lg--108.012d7684.jpg";